import { Component, Input, Signal, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../../services/auth-service';
import { ProfileService } from '../../services/profile-service';
import { IUser } from '../../../constants/interface/profile';
import { ERole } from '../../../constants/enum/role';

export interface INavLink {
  label: string;
  route: string;
}

@Component({
  selector: 'app-header',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {
  @Input() navLinks: INavLink[] = [
    { label: 'ABOUT', route: '/about' },
    { label: 'ASSESSMENTS', route: '/assessment' },
    { label: 'SERVICES', route: '/services' },
    { label: 'TESTIMONIALS', route: '/testimonials' },
    { label: 'STORE', route: '/store' }
  ];

  @Input() hideActions = false;

  isMenuOpen = signal(false);
  isLoggedIn: Signal<boolean>;
  profileData: Signal<IUser | null>;
  ERole = ERole;
  constructor(
    private authService: AuthService,
    private profileService: ProfileService
  ) {
    this.isLoggedIn = toSignal(this.authService.isLoggedIn, { initialValue: this.authService.checkIsLoggedIn() });
    this.profileData = toSignal(this.profileService.profileData, { initialValue: this.profileService.profileData.value })
  }

  toggleMenu(): void {
    this.isMenuOpen.update(v => !v);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  onSignOut(): void {
    this.closeMenu();
    this.profileService.logOut();
  }
}
